import { ERROR_COPY, goToConnections, providerLabel } from './connectResult';

function ConnectSelectOrgCtrl($auth, $state, $stateParams, ConnectionService) {
  'ngInject';

  const vm = this;
  vm.providerLabel = providerLabel($stateParams.provider || 'xero');
  vm.tenants = [];
  vm.selectedTenantId = null;
  vm.loading = true;
  vm.submitting = false;
  vm.errorMessage = null;

  vm.load = function () {
    vm.loading = true;
    vm.errorMessage = null;
    ConnectionService.pendingXeroOrganisations($stateParams.ticket, function (response) {
      vm.loading = false;
      if (response && response.status === 200 && response.data && response.data.tenants) {
        vm.tenants = response.data.tenants;
        if (vm.tenants.length === 1) vm.selectedTenantId = vm.tenants[0].tenant_id;
        return;
      }
      var reason = response && response.data && response.data.reason;
      vm.errorMessage = ERROR_COPY[reason] || ERROR_COPY.select_expired;
    });
  };

  vm.submit = function () {
    if (!vm.selectedTenantId || vm.submitting) return;
    vm.submitting = true;
    vm.errorMessage = null;
    ConnectionService.selectXeroOrganisation($stateParams.ticket, vm.selectedTenantId, function (response) {
      vm.submitting = false;
      if (response && response.status === 200 && response.data && response.data.organization) {
        $state.go('connectSuccess', {
          provider: 'xero',
          organization: response.data.organization
        }, { inherit: false });
        return;
      }
      var reason = response && response.data && response.data.reason;
      if (reason === 'already_connected') {
        $state.go('user.already_connected', {}, { inherit: false });
        return;
      }
      $state.go('connectError', { provider: 'xero', reason: reason || 'failed' }, { inherit: false });
    });
  };

  vm.retry = function () {
    goToConnections($auth, $state);
  };

  vm.load();
}

export default {
  name: 'ConnectSelectOrgCtrl',
  fn: ConnectSelectOrgCtrl
};
